import axios from "../../utils/axios";

export class MecsCuesService {
  createMecs(patientId: string, data: any) {
    return axios.post(`/patient/${patientId}/mecs-cues`, data);
  }

  getMecs(patientId: string, mecsId?: number) {
    const queryString = mecsId ? `?mecsId=${mecsId}` : "";
    return axios.get(`/patient/${patientId}/mecs-cues${queryString}`);
  }

  updateMecs(patientId: string, id: number, data: any) {
    return axios.patch(`/patient/${patientId}/mecs-cues/${id}`, data);
  }
}